import { render, staticRenderFns } from "./CruiseDetailsItinerary.vue?vue&type=template&id=83f20f92&"
import script from "./CruiseDetailsItinerary.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailsItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports